<template>
  <div>
    <SearchPopup :search="search" :save-search="saveFilters" :filters="filters" :saveMessage="localSaveMessage"
                 @update:saveMessage="localSaveMessage = $event" :clearData="clearData"  ref="popup"/>
    <SearchPopup :search="resetFilters" :save-search="saveFilters" :filters="filters" :saveMessage="localSaveMessage"
                 @update:saveMessage="localSaveMessage = $event" ref="reset-popup"/>
    <div class="search-filters-header">
      <div class="header-title">
        CICS Search
      </div>
      <div class="header-subtitle">
        What are you looking for today? Select the appropriate tab to specify search criteria.
      </div>
      <div class="filter-tabs-wrapper">
        <div class="filters-tab saved-searches-toggle" @click="toggleSavedSearches()" :style="{right: showSavedSearches ? '348px' : '0'}">
          <font-awesome-icon style="font-size: 32px; margin-left: 2px;" icon="cloud" color="white"></font-awesome-icon>
        </div>
      </div>
    </div>
    <div class="card search-filters-card">
      <div class="card-body search-filters-card-body">
        <b-collapse
            class="w-100"
            id="collapse-2"
            v-model="collapses.secondOpened"
        >
          <div class="form-container visible" id="methodology"
               ref="methodology-container">
            <CicsForm :filters="filters" :geo-types="fields.geographical_types" :get-cics-tag-values="getCicsTagValues"
                      @update:filters="filters = $event" ref="cics-form"></CicsForm>
          </div>
        </b-collapse>
        <div class="row w-100">
          <div class="col-6 tag-wrapper">
            <CurrentTags :remove-applied-filter="removeAppliedFilter" :remove-metric="removeMetric"
                         :filters="filters"></CurrentTags>
          </div>
          <div class="col-6 search-filters-actions-wrapper">
            <div class="d-flex justify-content-between w-100" style="margin-bottom: 20px;">
              <el-input v-model="searchName" :class="{'is-invalid': localSaveMessage.error}"
                        style="height: 40px;" placeholder="Enter search name" clearable
                        @input="resetSaveMessage">
                <template #append>
                  <div @click.prevent="saveFilters(searchName, filters)"><font-awesome-icon style="font-size: 37px; margin: 0 5px;" icon="cloud-upload-alt" color="white"></font-awesome-icon> </div>
                </template>
              </el-input>
            </div>
            <div class="d-flex justify-content-end align-items-center w-100">
              <button class="search-button-alt btn" type="button"
                      @click="() => $refs['reset-popup'].showPopup()">
                New search
              </button>
              <button class="search-button btn" type="button"
                      @click="searchStarted ? togglePopup() : search()">Search
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CicsForm from './CicsForm'
import { mapActions, mapGetters } from 'vuex'
import studiesGetters from '../../store/modules/studies/getterTypes'
import studiesActions from '../../store/modules/studies/actionTypes'
import getInitialFilters from '../../constants/searchFilters'
import _ from 'lodash'
import SearchPopup from '../Search/SearchPopup'
import CurrentTags from '../shared/CurrentTags'

export default {
  name: 'CicsFilters',
  emits: ['update:saveMessage'],
  components: { CurrentTags, CicsForm, SearchPopup },
  props: {
    fields: Object,
    parseData: Function,
    saveFilters: Function,
    toggleSavedSearches: Function,
    showSavedSearches: Boolean,
    saveMessage: Object,
    searchData: Function
  },
  data () {
    return {
      collapses: {
        firstOpened: true,
        secondOpened: false
      },
      filters: {},
      searchName: '',
      isReady: false,
      searchStarted: false,
      localSaveMessage: _.cloneDeep(this.saveMessage)
    }
  },
  computed: {
    ...mapGetters({
      filterValues: studiesGetters.GET_CICS_FILTERS
    }),
    tagsList () {
      return this.filters
    },
    areFiltersEmpty () {
      const data = this.parseData(_.cloneDeep(this.filters))
      return data.length
    }
  },
  methods: {
    ...mapActions({
      updateStoreFilters: studiesActions.UPDATE_CICS_FILTERS,
      resetStoreFilters: studiesActions.RESET_CICS_FILTERS,
      clearAnalytics: studiesActions.CLEAR_ANALYTICS,
      clearSummaries: studiesActions.CLEAR_STUDY_SUMMARIES,
      clearFragrances: studiesActions.CLEAR_FRAGRANCES,
      clearFiles: studiesActions.CLEAR_FILES
    }),
    getCicsTagValues (tag) {
      return this.fields.input_values ? this.fields.input_values[tag] : []
    },
    search () {
      this.searchStarted = true
      this.updateStoreFilters(_.cloneDeep(this.filters))
      this.clearData()
      this.searchData(this.parseData(this.filters), { file_type: '', search_phrase: '' })
    },
    checkIfTagVisible (tag) {
      switch (tag) {
        case 'age':
          const { startAge, endAge } = this.filters
          return (startAge.value && startAge.value !== 0) || (endAge.value && endAge.value !== 99)
        default:
          if ((tag.value && !this.isArray(tag.value)) || (this.isArray(tag.value) && tag.value.length)) {
            if (['Start year', 'End year'].includes(tag.label)) {
              return !(tag.label === 'Start year' && tag.value === this.yearInput.min) && !(tag.label === 'End year' && tag.value === this.yearInput.max)
            }
            return !['Higher age limit', 'Lower age limit'].includes(tag.label)
          }
      }
    },
    isArray (value) {
      return Array.isArray(value)
    },
    togglePopup (url) {
      this.$refs.popup.showPopup(url)
    },
    resetSaveMessage () {
      this.localSaveMessage = {
        ...this.localSaveMessage,
        error: false,
        value: ''
      }
    },
    clearData () {
      this.clearAnalytics()
      this.clearSummaries()
      this.clearFragrances()
      this.clearFiles()
      this.resetFilters()
    },
    async resetFilters () {
      await this.resetStoreFilters()
      this.refreshFilters()
      this.collapses = {
        firstOpened: false,
        secondOpened: true
      }
    },
    refreshFilters () {
      this.filters = _.cloneDeep({ ...this.filters, ...this.filterValues })
      this.removeAppliedFilter('age')
    },
    toggleCollapsibleContent () {
      this.collapses.firstOpened = !this.collapses.firstOpened
      this.collapses.secondOpened = !this.collapses.secondOpened
    },
    removeMetric (id) {
      return id
    },
    removeAppliedFilter (tag) {
      switch (tag) {
        case 'age':
          const form = this.$refs['cics-form']
          if (form) {
            form.clearAgeInput()
          }
          break
        default:
          Object.keys(this.filters).forEach(category => {
            const filter = this.filters[category].label === tag ? this.filters[category] : undefined
            if (filter) {
              this.$set(filter, 'value', '')
            }
          })
      }
    }
  },
  beforeMount () {
    if (Object.keys(this.filterValues).length) {
      this.refreshFilters()
    }
    this.filters = _.cloneDeep(getInitialFilters.getCicsFilters())
  },
  created () {
    this.isReady = true
    setTimeout(() => {
      this.collapses = {
        firstOpened: false,
        secondOpened: true
      }
      this.isReady = false
    }, 800)
  },
  watch: {
    saveMessage: {
      deep: true,
      handler (value) {
        if (!_.isEqual(value, this.localSaveMessage)) {
          this.localSaveMessage = _.cloneDeep(value)
        }
      }
    },
    localSaveMessage: {
      deep: true,
      handler (value) {
        if (!_.isEqual(value, this.saveMessage)) {
          this.$emit('update:saveMessage', _.cloneDeep(value))
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/scss/variables";

.search-filters-header {
  height: 130px;
  width: 100%;
  background: transparent linear-gradient(266deg, rgba(115,178,224, 0.73) 0%, rgba(0,39,204, 0.73) 100%) 0% 0% no-repeat padding-box;
  box-shadow: 0 3px 6px #00000029;
  border-top: 1px solid #231A44;
  border-bottom: 1px solid #231A44;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-left: 34px;
  padding-top: 13px;
  position: relative;

  .header-title {
    width: 309px;
    height: 56px;
    font-family: 'Source Sans Pro', sans-serif;
    font-size: 45px;
    line-height: 30px;
    font-weight: 900;
    letter-spacing: 0.9px;
    text-transform: uppercase;
    color: white;
    white-space: nowrap;
    display: flex;
    justify-content: start;
    align-items: center;
  }

  .header-subtitle {
    height: 30px;
    color: white;
    font-family: 'Open Sans', sans-serif;
    font-size: 22px;
    line-height: 30px;
    letter-spacing: 0;
    margin-bottom: 6px;
  }

  .filter-tabs-wrapper {
    display: flex;
    justify-content: flex-end;
    position: absolute;
    bottom: -1px;
    right: 0;
    z-index: 3;
    width: 100%;
    padding-right: 80px;

    .filters-tab {
      max-width: 240px;
      width: 100%;
      height: 44px;
      color: $dusty-blue;
      border: 1px solid #25232C;
      background-color: $silver;
      display: flex;
      justify-content: center;
      align-items: center;
      font-family: 'Source Sans Pro', sans-serif;
      font-size: 20px;
      line-height: 25px;
      letter-spacing: 0;
      cursor: pointer;
      border-left: 0;

      &:first-of-type {
        border-left: 1px solid #25232C;
      }
    }

    .saved-searches-toggle {
      position: absolute;
      width: 80px;
      transition: right 0.35s ease-in-out;
      background-color: #3981FF;
      bottom: 0;
      border-left: 1px solid #25232C;
      border-right: 1px solid #25232C;
    }

    .selected {
      border-bottom: 0;
      background-color: $light-grey !important;
      font-weight: 900;
      position: relative;

      &:before {
        content: '';
        position: absolute;
        bottom: 0;
        width: 80%;
        left: 10%; /*this centers it based on the above width*/
        border-bottom: 2px solid $dusty-blue;
      }
    }
  }
}

.search-filters-card {
  margin-bottom: 0;
  box-shadow: 0 5px 7px #999999;
  background-color: $light-grey;
  border: 0;

  .search-filters-card-body {
    display: flex;
    align-items: center;
    flex-direction: column;
    padding: 38px 132px;
  }

  .search-filters-actions-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 582px;
    height: 118px;
    align-self: flex-end;
    margin-top: 30px;

    .search-button {
      width: 230px;
      height: 48px;
      background-color: $blueberry;
      font-family: 'Open Sans', sans-serif;
      font-size: 16px;
      font-weight: 800;
      line-height: 30px;
      letter-spacing: 0;
      border-radius: 4px;
      color: white;
      text-transform: uppercase;

      transition: background-color 0.2s linear;

      &:hover {
        background-color: #9256D9;
      }
    }

    .search-button-alt {
      font-family: 'Open Sans', sans-serif;
      font-size: 16px;
      font-weight: 600;
      line-height: 20px;
      letter-spacing: 0;
      width: 161px;
      height: 48px;
      background-color: #F8F8F8;
      border-radius: 4px;
      color: $button-text;
      text-transform: uppercase;
      transition: all 0.2s linear;
      margin-right: 30px;

      &:hover {
        border-color: #dedede;
        background-color: white;
      }
    }
  }
}

.filters-header {
  padding: 12px 17px;
  cursor: pointer;
}

.tag-wrapper {
  margin-top: 40px;
}

.input-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
}

.input-wrapper input {
  width: 100%;
}

.input-wrapper .el-select {
  width: 100%;
}

.input-wrapper label {
  font-size: 11px;
  color: $input-label;
  margin-bottom: 2px;
  margin-left: 2px;
}

.form-container {
  opacity: 0;
  height: 0;
  overflow: hidden;
  transition: opacity 0.3s ease-in;
}

.visible {
  height: unset;
  opacity: 1;
}

.visible-ie {
  height: auto;
  opacity: 1;
}

.panel-switches-wrapper {
  padding: 0 0 20px;
  width: 100%;
  font-size: 15px;
  display: flex;
  justify-content: flex-end;
}

.panel-switch {
  padding-left: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #c1c4c7;
  transition: color 0.2s linear;
  cursor: pointer;
}

.panel-switch:hover {
  color: #20a8d8
}

.selected {
  color: #20a8d8
}

.panel-icon {
  font-size: 12px;
  margin-right: 3px;
}

.slider-wrapper {
  width: 92%;
  margin: -7px auto 0;
}

.applied-filter {
  border-top: 1px dashed #d1d4d7;
  transition: background-color 0.2s linear;
}

.applied-filter:first-of-type {
  margin-top: 0 !important;
}

.applied-filter:last-of-type {
  border-bottom: 1px dashed #d1d4d7;
  margin-bottom: 10px !important;
}

.remove-applied-filter {
  font-size: 14px;
  color: #d1d4d7;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #d1d4d7;
  width: 15px;
  height: 15px;
  transform: rotate(45deg);
  cursor: pointer;
  transition: 0.2s linear;
}

.remove-applied-filter:hover {
  color: black;
  border: 1px solid black;
}

.is-invalid > > > .el-input__inner {
  border-color: #f86c6b;
}

.error-message {
  position: absolute;
  top: 40px;
  left: 3px;
  color: #f86c6b;
  font-size: 12px;
}

.success-message {
  position: absolute;
  top: 40px;
  left: 3px;
  color: #2d884d;
  font-size: 12px;
}

.remove-applied-metric {
  font-size: 14px;
  color: #d1d4d7;
  position: absolute;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #d1d4d7;
  width: 15px;
  height: 15px;
  transform: rotate(45deg);
  cursor: pointer;
  transition: 0.2s linear;
  top: 2px;
  right: 15px;
}

.remove-applied-metric:hover {
  color: black;
  border: 1px solid black;
}

.warning-text {
  position: absolute;
  top: 15px;
  right: 30px;
  font-family: 'Open Sans', sans-serif;
  font-size: 14px;
  font-weight: 800;
  line-height: 26px;
  color: $red-600;
}
</style>
